import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/esm/Button';
import { useNavigate } from 'react-router-dom';

function AddProctorSuccess() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate("/AdministratorDashboard", {state: {toProctor: true}});
    };

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Container className="mt-5 text-center centered-form rounded">
            <Row>
                <Col>
                    <h2>Proctor Availability Submitted Successfully!</h2>
                    <Button 
                        variant="success"
                        className="mt-5"
                        onClick={handleGoBack}
                    >
                        Go Back To Dashboard
                    </Button>
                </Col>
            </Row>
        </Container>
        </div>
    );
}

export default AddProctorSuccess; 